import React from 'react'
import Bredcom from '../Bredcom/Main'
import Loan from '../Menapplynow/Loan'

const ApplyNow = () => {
  return (
    <>
      <Bredcom title={"Home"} subtitle={"APPLY NOW"} link={"Apply Now"}/>
      <Loan />
    </>
  )
}

export default ApplyNow